import { IdLoca } from "../../utils/i18n/IdLoca";
import { StatusCode } from "../../utils/network/generated/protoTypes";
export var mapCoopInvitePlayerError = new Map()
    .set(StatusCode.LIMIT_REACHED, IdLoca.maxLimitReached)
    .set(StatusCode.NO_PERMISSION, IdLoca.floatingText_leadersAndDeputiesOnly)
    .set(StatusCode.INVALID_COOP_LEVEL, IdLoca.floatingText_coopInviteDisabled)
    .set(StatusCode.INVALID_COOP_ID, IdLoca.floatingText_coopInviteJoinedAlready)
    .set(StatusCode.INVALID_PLAYER_ID, IdLoca.floatingText_coopInviteOpenFromUs)
    .set(StatusCode.INVALID_AMOUNT, IdLoca.floatingText_coopInviteOpen);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/mapCoopInvitePlayerError.ts
// module id = 501
// module chunks = 3